import ActionButtons from "./ActionButtons";
import DOMPurify from 'dompurify';

const CaseTemplate = ({ content }) => {
    
    return (
        
            <div className="w-full h-full rounded-lg flex-col justify-between items-start gap-10 flex pb-[40px]">
                <div className="w-full flex flex-col sm:flex-row justify-start items-start gap-5">

                    <div 
                        className={`w-full justify-start items-start text-[#9c7083] text-[20px] lg:text-[24px] font-bold font-['Open Sans'] ${ content.image && 'w-[280px] lg:w-[564px]'}`}
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content.title) }}
                        />

                    {content.image && 
                        <div className="w-full md:w-[200px] h-full flex flex-col justify-center items-center ">
                            <img src={content.image} alt={content.alt} className="max-w-full xl:w-[200px] max-h-auto xl:h-[200px] object-contain" />
                        </div>
                    }
                </div>

                {content.result.length > 0 && (
                <div className="flex justify-start items-center md:mt-[-10px] xl:mt-[-120px]">
                    <div className="text-[#d3aa86] text-xl font-bold font-['Open Sans']">
                        Результат:
                    </div>
                </div>                        
                )}
                
                <div className="justify-start items-center flex flex-col sm:flex-row gap-3 lg:gap-10">
                    {content.result.map((item, index) => (
                            <div key={index} className="flex flex-row justify-start items-center gap-6 w-full bg-white">
                                
                                <div className="text-[#544a28] text-2xl lg:text-3xl font-normal font-['Open Sans']" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.value) }} />
                                
                                <div className="lg:w-96 lg:h-11 text-[#544a28] text-base lg:text-lg font-normal font-['Open Sans']" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.title) }} />
                        </div>
                    ))}
                </div>

               <ActionButtons links={content.links || []}  />
            </div>
    )
}

export default CaseTemplate;